import Vue from 'vue';
import App from './App.vue';
import Router from './router';
import store from './store';
import contentful from './services/contentful-service';

Vue.config.productionTip = false;

contentful.getPages().then((pages) => {
  const router = new Router(pages);
  new Vue({
    router: router.getRouter(),
    store,
    render: (h) => h(App),
  }).$mount('#app');
});
